import { render, staticRenderFns } from "./StatItem.vue?vue&type=template&id=f239af04&scoped=true&lang=pug"
import script from "./StatItem.vue?vue&type=script&lang=js"
export * from "./StatItem.vue?vue&type=script&lang=js"
import style0 from "./StatItem.vue?vue&type=style&index=0&id=f239af04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f239af04",
  null
  
)

export default component.exports